import React, { useContext } from "react";
import { TranslationContext } from "../../helpers/Context";
import { useAnalytics } from "../../hooks/useAnalytics";

const LanguageSelector = () => {
  const { setLanguage, language } = useContext(TranslationContext);
  const { trackSettingsChange } = useAnalytics();
  
  const handleChangeLanguage = (e) => {
    const newLanguage = e.target.value;
    if(setLanguage){
      setLanguage(newLanguage);
      
      // Analytics
      trackSettingsChange('language', newLanguage, {
        previous_language: language,
        user_preference: true,
        source: 'language_selector'
      });
    }
  }
  return (
    <select className="bg-transparent" onChange={handleChangeLanguage} defaultValue={language}>
      <option value="ES"> [ES] 🇪🇸</option>
      <option value="EN"> [EN] 🇬🇧 </option>
      <option value="IT"> [IT] 🇮🇹</option>
      <option value="PT"> [PT] 🇵🇹</option>
    </select>
  );
};

export default LanguageSelector;